import styledComp from 'styled-components';
import { Colors, Styling } from '../../../../constants';

export const Container = styledComp.div`
  flex-basis: min-content;
  background: ${Colors.PAPER};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: auto;
`;
